$traceurRuntime.ModuleStore.getAnonymousModule(function() {
  "use strict";
  angular.module('app.test').controller('testCtrl', (function($scope, $state, $stateParams, TestScore, testData, AudioManager) {
    $scope.title = testData.title;
    $scope.subtitle = testData.subtitle;
    $scope.image = testData.image;
    $scope.base_dir = testData.base_directory;
    $scope.site_url = testData.site_url;
    $scope.startQuiz = (function() {
      TestScore.reset();
      $state.go('test.question', {question: 1});
    });
  })).controller('testQuestionCtrl', (function($rootScope, $scope, $state, $stateParams, TestScore, testData, AudioManager) {
    AudioManager.load();
    $scope.stopQuiz = (function() {
      TestScore.reset();
      $state.go('test.start', $stateParams, {reload: true});
    });
    $scope.answers = TestScore.get();
    if (_.isEmpty($scope.answers)) {
      $state.go('test.question', {question: 1});
    }
    var quiz = testData.questions;
    $scope.question_id = parseInt($stateParams.question);
    $scope.question = quiz[$scope.question_id - 1];
    $scope.total = testData.questions.length;
    $scope.next = (function() {
      TestScore.addScore($scope.question_id, $scope.answers[$scope.question_id]);
      if ($scope.question_id < testData.questions.length) {
        $stateParams.question = $scope.question_id + 1;
        $state.go('test.question', $stateParams, {reload: true});
      } else {
        $stateParams.result = $scope.scores(TestScore.get(), testData.questions);
        $state.go('test.results', $stateParams, {reload: true});
      }
    });
    $scope.previous = (function() {
      if ($scope.question_id == 1) {
        $state.go('test.start');
      } else {
        $stateParams.question = $scope.question_id - 1;
        $state.go('test.question', $stateParams, {reload: true});
      }
    });
    $scope.scores = (function(answers, questions) {
      var result = {};
      _.each(answers, function(value, key) {
        var score = questions[key - 1].scores[value - 1];
        _.each(score, function(v, k) {
          result[k] = (result[k] ? result[k] + v : v);
        });
      });
      var topscore = _.max(Object.keys(result), function(o) {
        return result[o];
      });
      return topscore;
    });
  })).controller('testResultsCtrl', (function($scope, $state, $stateParams, testData, TestScore, AudioManager) {
    AudioManager.load();
    $scope.answers = TestScore.get();
    $scope.resultFooter = testData.results_footer;
    $scope.result = _.find(testData.results, {id: $stateParams.result});
    $scope.base_dir = testData.base_directory;
    $scope.site_url = testData.site_url;
    $scope.print = (function() {
      window.print();
    });
    $scope.stopQuiz = (function() {
      TestScore.reset();
      $state.go('test.start', $stateParams, {reload: true});
    });
    var ShareSubject = encodeURI('Bekijk mijn Resultaten');
    var ShareUrl = encodeURI($scope.site_url + '/test/#/' + $stateParams.result);
    $scope.whatsappShare = 'whatsapp://send?text=' + ShareSubject + ' - ' + ShareUrl;
    $scope.emailShare = 'mailto:?subject=' + ShareSubject + '&body=Bekijk de resultaten hier: ' + ShareUrl;
  }));
  ;
  return {};
});

